module.exports = __webpack_public_path__ + "img/login-bg.2d6f86c7.png";